import { Row, Col } from "antd";
import { withTranslation } from "react-i18next";
import { SvgIcon } from "../../common/SvgIcon";
import Container from "../../common/Container";
import {
    FooterSection,
    Title,
    SubTitle,
    NavLink,
    Extra,
    LogoContainer,
    Para,
    Contact,
    WebsiteLinks
} from "./styles";

interface SocialLinkProps {
    href: string;
    src: string;
}

const Footer = () => {

    const SocialLink = ({ href, src }: SocialLinkProps & { style?: React.CSSProperties }) => {
        return (
            <a
                href={href}
                target="_blank"
                rel="noopener noreferrer"
                key={src}
                aria-label={src}
                style={{ marginRight: "0.8rem" }}
            >
                <SvgIcon src={src} width="30px" height="30px" />
            </a>
        );
    };

    return (
        <>
            <FooterSection>
                <Container>
                    <Row justify="space-between">
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <Title>{"Contact"}</Title>
                            <Para>
                                {`Do you have any question? Feel free to reach out.`}
                            </Para>
                            <a href="mailto:pr@popmso.com">
                                <Contact>
                                    <img
                                        src="/img/icons/email.png"
                                        alt="email icon"
                                        style={{ width: "20px", height: "20px", marginRight: "16px", verticalAlign: "middle" }}
                                    />
                                    pr@popmso.com
                                </Contact>
                            </a>
                            <a href="tel:7609270927">
                                <Contact>
                                    <img
                                        src="/img/icons/call.png"
                                        alt="call icon"
                                        style={{ width: "20px", height: "20px", marginRight: "16px", verticalAlign: "middle" }}
                                    />
                                    760-927-0927
                                </Contact>
                            </a>

                        </Col>
                        <Col lg={8} md={8} sm={12} xs={12}>
                            <Title>{"Address"}</Title>
                            <SubTitle>{"HQ"}</SubTitle>
                            <Para>
                                {`6800 Lincoln Ave Suite 200`}<br />
                                {`Buena Park, CA 90620`}
                            </Para>
                        </Col>
                        <Col lg={4} md={4} sm={12} xs={12}>
                            <Title>{"Websites"}</Title>
                            <WebsiteLinks>
                                <SocialLink
                                    href="https://popmso.com/Html/"
                                    src="mso.svg"
                                />
                                <SocialLink
                                    href="https://centeripa.com/"
                                    src="center.svg"
                                />
                            </WebsiteLinks>
                        </Col>
                    </Row>
                </Container>
            </FooterSection>
            <Extra>
                <Container border={true}>
                    <Row
                        justify="space-between"
                        align="middle"
                        style={{ paddingTop: "2rem" }}
                    >
                        <NavLink to="/">
                            <LogoContainer>
                                <SvgIcon
                                    src="logo.svg"
                                    aria-label="homepage"
                                    width="300px"
                                    height="30px"
                                />
                            </LogoContainer>
                        </NavLink>
                    </Row>
                </Container>
            </Extra>
        </>
    );
};

export default withTranslation()(Footer);
